/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PracticeProfileDto } from './PracticeProfileDto';
import {
    PracticeProfileDtoFromJSON,
    PracticeProfileDtoFromJSONTyped,
    PracticeProfileDtoToJSON,
    PracticeProfileDtoToJSONTyped,
} from './PracticeProfileDto';

/**
 * 
 * @export
 * @interface GoogleSignInUserDto
 */
export interface GoogleSignInUserDto {
    /**
     * 
     * @type {string}
     * @memberof GoogleSignInUserDto
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSignInUserDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSignInUserDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSignInUserDto
     */
    photoURL?: string;
    /**
     * 
     * @type {PracticeProfileDto}
     * @memberof GoogleSignInUserDto
     */
    profile?: PracticeProfileDto;
}

/**
 * Check if a given object implements the GoogleSignInUserDto interface.
 */
export function instanceOfGoogleSignInUserDto(value: object): value is GoogleSignInUserDto {
    if (!('uid' in value) || value['uid'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function GoogleSignInUserDtoFromJSON(json: any): GoogleSignInUserDto {
    return GoogleSignInUserDtoFromJSONTyped(json, false);
}

export function GoogleSignInUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSignInUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'uid': json['uid'],
        'email': json['email'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'photoURL': json['photoURL'] == null ? undefined : json['photoURL'],
        'profile': json['profile'] == null ? undefined : PracticeProfileDtoFromJSON(json['profile']),
    };
}

export function GoogleSignInUserDtoToJSON(json: any): GoogleSignInUserDto {
    return GoogleSignInUserDtoToJSONTyped(json, false);
}

export function GoogleSignInUserDtoToJSONTyped(value?: GoogleSignInUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uid': value['uid'],
        'email': value['email'],
        'displayName': value['displayName'],
        'photoURL': value['photoURL'],
        'profile': PracticeProfileDtoToJSON(value['profile']),
    };
}

